import { addFollowed } from '../_idMap/actions';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAllFollowed } from '@api/followers/getAllFollowed';

export const getCoreFollowedAllSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) => addFollowed(response.results)
		]
	},
	name: 'CoreFollowedAll',
	receive: true,
	request: 'optional',
	requestHandler: getAllFollowed,
	retainDataOnRequest: true
});
